"use strict";

exports.__esModule = true;
var _MetricChartSeriesControls = require("./MetricChartSeriesControls");
Object.keys(_MetricChartSeriesControls).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MetricChartSeriesControls[key]) return;
  exports[key] = _MetricChartSeriesControls[key];
});